import React from "react";
import PropTypes from "prop-types";
//import ReactDOMServer from 'react-dom/server';
import AmCharts from "@amcharts/amcharts3-react";
import SmartTimeSeriesRenderer from "../SmartTimeSeriesRenderer";
import Debounce from "debounce";

const ScanChart = ({ data, lang, speedUnit, cursorCallback }) => {
  let listeners = [];
  if (cursorCallback != null) {
    let filteredCallback = event => {
      if (event.index > 0 && event.index <= data.length - 1) {
        let value = data[event.index];
        cursorCallback(value);
      }
    };
    let debouncedCallback = Debounce(filteredCallback, 50, true);
    let cursorListener = { event: "changed", method: debouncedCallback };
    listeners.push(cursorListener);
  }

  let campoVelocidad = "ECU_Velocidad";
  if (speedUnit === "Mi") {
    campoVelocidad = "MPH";
  }

  let config = {
    type: "serial",
    theme: "light",
    path: "https://www.amcharts.com/lib/3/",
    language: lang._code,
    marginTop: 0,
    marginRight: 20,
    dataProvider: data,
    synchronizeGrid: true,
    valueAxes: [
      {
        id: "v1",
        axisColor: "#F66B34",
        axisThickness: 2,
        axisAlpha: 1,
        position: "left",
        title: lang.VelocidadMotor + " (RPM)"
      },
      {
        id: "v2",
        axisColor: "#006B34",
        offset: 85,
        axisThickness: 2,
        axisAlpha: 1,
        position: "left",
        title: lang.VelocidadVehiculo + " (" + speedUnit + "/h)"
      }
    ],
    mouseWheelZoomEnabled: false,
    graphs: [
      {
        id: "g1",
        valueAxis: "v1",
        bullet: "round",
        bulletBorderAlpha: 1,
        bulletColor: "#F66B34",
        hideBulletsCount: 1,
        title: "Economia Combustible",
        valueField: "RPM",
        useLineColorForBulletBorder: true,
        lineColor: "#F66B34",
        lineThickness: 3,
        showBalloon: false
      },
      {
        id: "g2",
        valueAxis: "v2",
        bullet: "round",
        bulletBorderAlpha: 1,
        bulletColor: "#F66B34",
        hideBulletsCount: 1,
        title: "Economia Combustible",
        valueField: campoVelocidad,
        useLineColorForBulletBorder: true,
        lineColor: "#006B34",
        lineThickness: 3,
        showBalloon: false
      }
    ],
    chartScrollbar: {
      graph: "g5",
      gridAlpha: 0,
      color: "#888888",
      scrollbarHeight: 55,
      backgroundAlpha: 0,
      selectedBackgroundAlpha: 0.1,
      selectedBackgroundColor: "#888888",
      graphFillAlpha: 0,
      autoGridCount: true,
      selectedGraphFillAlpha: 0,
      graphLineAlpha: 0.2,
      graphLineColor: "#c2c2c2",
      selectedGraphLineColor: "#888888",
      selectedGraphLineAlpha: 1
    },
    chartCursor: {
      cursorPosition: "mouse",
      cursorColor: "#F05A30",
      categoryBalloonDateFormat: "YYYY-MM-DD HH:NN:SS",
      listeners: listeners
    },
    categoryField: "Fecha",
    categoryAxis: {
      parseDates: true,
      startOnAxis: true,
      axisColor: "#DADADA",
      gridAlpha: 0.07,
      minPeriod: "ss"
    }
  };

  return (
    <AmCharts.React
      style={{
        width: "100%",
        height: "100%"
      }}
      options={config}
    />
  );
};

const ScanTimeseries = ({ data, lang, speedUnit, cursorCallback }) => (
  <SmartTimeSeriesRenderer
    chart={ScanChart}
    data={data}
    lang={lang}
    speedUnit={speedUnit}
    cursorCallback={cursorCallback}
  />
);

ScanTimeseries.propTypes = {
  data: PropTypes.array.isRequired,
  lang: PropTypes.object.isRequired,
  speedUnit: PropTypes.string.isRequired,
  cursorCallback: PropTypes.func
};

export default ScanTimeseries;



// WEBPACK FOOTER //
// ./src/charts/ScanTimeseries/ScanTimeseriesAmcharts.js